<template>
	<div class="slider-open">
		<div class="slider-open-top"> 
			<div class="slider-open-left">切换推荐类目</div>
			<div  class="slider-right" @click="showAllPart">
				<div class="slider-triangle-up"></div>
			</div>
		</div>
		<div class="slider-open-buttom">
			<ul class = "slider-open-buttom-ul">
				<li class = "open-item" v-for="(sliderList,index) in sliderLists" :key ="index" :class ="{'open-item-active':index == currentPart}" @click = "changePart(index)">
					<a :href="'#anchor-'+index" class = "anchor" >{{sliderList.title}}</a>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import {mapState} from 'vuex';

export default{
	computed: {
		...mapState([
			'currentPart',
			'isShowAllPart',
			'sliderLists', //循环的slider数据
			'currentScrollTop'
		])
	},
	// data() {
	// 	return {
	// 		currentScrollTop: 0
	// 	};
	// },
	methods: {
		showAllPart() {
			//顶部收起全部选项的时候恢复页面滚动
			document.getElementById('app').className = ' ';
			this.$store.commit({
				type: 'IS_SHOW_ALL_PART',
				state: !this.isShowAllPart
			});
			//没有修改当前模块，直接返回展开前位置
			document.body.scrollTop = this.currentScrollTop;
		},
		changePart(index) {
			//顶部收起全部选项的时候恢复页面滚动
			document.getElementById('app').className = ' ';
			this.$store.commit({
				type: 'IS_SHOW_ALL_PART',
				state: !this.isShowAllPart
			});
			//更改currentPart
			this.$store.commit({
				type: 'CHANGE_CURRENTPART',
				currentPart: index
			});
			window.clickLog && window.clickLog('from=m_aggregation_guideclick');
		}
	}
};
</script>
<style lang ="scss">
@import '../../assets/style/public.scss';
.slider-open{
	position:fixed;
	top:0;
	width:100%;
	height:100%;
	background: rgba(0,0,0,0.70);
	.slider-open-top{
		height:$height;
		padding-left:px2rem(30px);
		font-size:$font-size;
		color:$color;
		background:$white;
		border-bottom:1px solid #F3F3F3;
		.slider-open-left{
		line-height:$height;
		}
		.slider-right{
			@extend .slider-right-common;
			.slider-triangle-up{
				position: relative;
				width: 100%;
				height: 100%;
				&:before{
					@extend .slider-triangle-common;
					content: '\e902';
					color: #ccc;
				}
			}
		}
	}
	.slider-open-buttom{
		padding:px2rem(30px) px2rem(30px) px2rem(10px);
		background:$white;
		font-size:0;
		.slider-open-buttom-ul{
			padding-bottom: px2rem(20px);
		}
		.open-item{
			display:inline-block;
			font-size:px2rem(26px);
			color:#666;
			padding:px2rem(22px) px2rem(30px);
			margin:0 px2rem(26px) px2rem(26px) 0;
			border-radius:px2rem(50px);
			background: #F9FAFC;
		}
		.open-item-active{
			color: #FF552E;
			background: #FFF7F5;

		}
	}
}
</style>


// WEBPACK FOOTER //
// sliderOn.vue?1c8faea7